import {CreateView} from '@src/components/_views/configurable/CreateView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import ExternalApplicationForm from './ExternalApplicationForm';

export class ExternalApplicationCreateForm extends CreateView {
    protected getFormComponent() {
        return ExternalApplicationForm as any;
    }
}

export default ExternalApplicationCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(ExternalApplicationCreateForm));
